import { memo, FunctionComponent } from 'react';

// libs
import classnames from 'classnames';

// components

// styles
import styles from './AvatarStack.module.scss';
import Image from '@Components/Utils/Image';

const totalRender = 3;

interface AvatarStackProps {
    width?: number;
    height?: number;
    className?: string;
    avatarClass?: string;
    avatars?: Array<string>;
}

const AvatarStack: FunctionComponent<AvatarStackProps> = memo(({ width, height, avatars, className, avatarClass }) => {
    const wrapperClassName = classnames([styles.wrapper, className]);
    const avatarClassName = classnames([styles.user_avatar, avatarClass]);

    const renderAvatar = () => {
        return [...Array(totalRender)].map((_item, index) => (
            <Image width={width} height={height} src={avatars[index]} className={avatarClassName} key={`avatar-item-${index}`} style={{ width: `${width}px`, height: `${height}px` }} />
        ));
    };

    return <div className={wrapperClassName}>{renderAvatar()}</div>;
});

AvatarStack.defaultProps = {
    width: 34,
    height: 34,
    className: '',
    avatarClass: '',
    avatars: ['/assets/bottomAction/avatar_0.png', '/assets/bottomAction/avatar_1.png', '/assets/bottomAction/avatar_2.png'],
};

export default AvatarStack;
